import groundcover from '@groundcover/browser';

// Shared with logger-rum so it can fall back to console when init never ran —
// the SDK silently drops sendCustomEvent/captureException calls pre-init.
// eslint-disable-next-line import/prefer-default-export -- side-effect module
export const telemetryEnabled = Boolean(
	process.env.REACT_APP_NODE_ENV
	&& process.env.REACT_APP_GROUNDCOVER_ENDPOINT
	&& process.env.REACT_APP_GROUNDCOVER_API_KEY,
);

if (telemetryEnabled) {
	groundcover.init({
		apiKey: process.env.REACT_APP_GROUNDCOVER_API_KEY,
		dsn: `https://${process.env.REACT_APP_GROUNDCOVER_ENDPOINT}`,
		cluster: `greenroom-${process.env.REACT_APP_NODE_ENV}`,
		environment: process.env.REACT_APP_NODE_ENV,
		appId: 'greenroom-browser',
		options: { debug: process.env.REACT_APP_GROUNDCOVER_DEBUG === 'true' },
	});
}
